function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "surface1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M80.625,21.5c-8.86035,0 -16.125,7.26465 -16.125,16.125c0,8.86035 7.26465,16.125 16.125,16.125c8.86035,0 16.125,-7.26465 16.125,-16.125c0,-8.86035 -7.26465,-16.125 -16.125,-16.125zM80.625,53.75h-10.75c-8.86035,0 -16.125,7.26465 -16.125,16.125v30.44433l10.75,10.75v39.43067h10.75v-43.88183l-10.75,-10.75v-25.99317c0,-3.02344 2.35156,-5.375 5.375,-5.375h21.5c3.02344,0 5.375,2.35156 5.375,5.375v25.99317l-10.75,10.75v43.88183h10.75v-39.43067l10.75,-10.75v-30.44433c0,-8.86035 -7.26465,-16.125 -16.125,-16.125zM80.625,32.25c3.02344,0 5.375,2.35156 5.375,5.375c0,3.02344 -2.35156,5.375 -5.375,5.375c-3.02344,0 -5.375,-2.35156 -5.375,-5.375c0,-3.02344 2.35156,-5.375 5.375,-5.375z"
}));

var SvgPassengerAdult = function SvgPassengerAdult(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 172 172",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPassengerAdult, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/passenger-adult.03c342d4.svg";
export { ForwardRef as ReactComponent };